// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSortUp, faCircle, faPaperclip, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueTouch from 'vue-touch'

library.add(faSortUp, faCircle, faPaperclip, faCheck, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueTouch)
Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.component('app-child', {
  data: function () {
    return {
      count: 0
    }
  },
  template: '<div></div>'
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js